import { useMutation, useQueryClient } from '@tanstack/react-query';

import { patientInquiryApi } from '../api/patient-inquiry.adapter';
import type {
  CreatePatientInquiryReplyInput,
  PatientInquiryDetail,
} from '../types/patient-inquiry.types';
import { patientInquiryQueryKeys } from './use-patient-inquiries';

// Reply / additional reply (PRD §3.3 — WRITE or Root). On success: surgical
// cache patch for the detail key (so the panel re-renders with the new thread +
// flipped status without a round-trip), plus list invalidation so the status
// badge column refreshes (PENDING → ANSWERED).
export function useReplyPatientInquiry() {
  const qc = useQueryClient();
  return useMutation<
    PatientInquiryDetail,
    Error,
    { id: number; input: CreatePatientInquiryReplyInput }
  >({
    mutationFn: ({ id, input }) => patientInquiryApi.replyPatientInquiry(id, input),
    onSuccess: (inquiry) => {
      qc.setQueryData(patientInquiryQueryKeys.detail(inquiry.id), inquiry);
      qc.invalidateQueries({ queryKey: patientInquiryQueryKeys.all });
    },
  });
}
